<div class="flex items-center justify-between mt-10">
  <h3 class="text-lg font-semibold">Edit Payment</h3>
</div>
<div class="-mx-2.5 mt-5 flex flex-wrap gap-y-5">
  <div class="w-1/2 px-2.5">
    @if (categoryChoices) {
      <app-select [height]="'11'" [control]="form.controls.category" [choices]="categoryChoices" label="Category"></app-select>
    }
  </div>
  <div class="w-1/2 px-2.5">
    <app-text-input [mask]="'separator.2'" [thousandSeparator]="','"  [control]="form.controls.amount" [name]="'amount'" [placeholder]="'0.00'" [label]="'&pound; Amount Due'" [disabled]="isSystemGeneratedPayment"></app-text-input>
    @if (isSystemGeneratedPayment) {
      <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
        <span class="inline-flex items-center gap-1">
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
          Auto-calculated
        </span>
      </p>
    }
  </div>
  <div class="w-full px-2.5">
    <app-textarea [control]="form.controls.description" [name]="'description'" [placeholder]="'Description'" [label]="'Description'"></app-textarea>
  </div>
  <div class="w-1/2 px-2.5">
    <app-date-picker [control]="form.controls.date_due" [label]="'Date Due'"></app-date-picker>
  </div>
  <div class="w-1/2 px-2.5">
    <app-text-input [mask]="'separator.2'" [thousandSeparator]="','"  [control]="form.controls.amount_paid" [name]="'amount_paid'" [placeholder]="'0.00'" [label]="'&pound; Amount Paid'"></app-text-input>
    <div class="mt-1 flex gap-2">
      <button type="button" class="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded hover:bg-blue-200"
              (click)="fillFullAmount()">Fill Full Amount</button>
      <button type="button" class="text-xs px-2 py-1 bg-green-100 text-green-700 rounded hover:bg-green-200"
              (click)="fillHalfAmount()">Fill 50%</button>
      <button type="button" class="text-xs px-2 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200"
              (click)="clearAmountPaid()">Clear</button>
    </div>
  </div>
  <div class="w-1/2 px-2.5">
    <app-date-picker [control]="form.controls.date_paid" [label]="'Date Paid'"></app-date-picker>
    <div class="mt-1 flex gap-2">
      <button type="button" class="text-xs px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
              (click)="fillToday()">Today</button>
      <button type="button" class="text-xs px-2 py-1 bg-red-100 text-red-700 rounded hover:bg-red-200"
              (click)="clearDatePaid()">Clear</button>
    </div>
  </div>
  <div class="w-1/2 px-2.5">
    <app-checkbox [control]="form.controls.is_reservation_fee" [label]="'Is Reservation Fee'"></app-checkbox>
  </div>
  <div class="flex flex-row w-full justify-between align-bottom">
    <div class="flex justify-start px-2.5">
      <app-button [label]="'Cancel'" [style]="'secondary'" (click)="cancel()"></app-button>
    </div>
    <div class="flex justify-end px-2.5">
      <app-button [label]="'Update Payment'" [disabled]="!form.valid || form.pristine" (click)="save()"></app-button>
    </div>
  </div>
</div>
